import './RouteCollectionTile.scss'

import React from 'react'

import { Tag } from '../Tag'
import { translated } from '../_translation'

/**
 * Tile for use in grids that represents a route.
 * @param {Object} props
 * @param {import("../../js/entities").RouteCollection} [props.routeCollection]
 * @param {string} [props.icon] shown if collection has no image
 */
const RouteCollectionTile = ({ gettext, routeCollection, icon }) => {
    const collection = gettext('Collection')
    const routeCollectionImage = gettext('Route collection image')
    const routes = gettext('Routes')

    if (!routeCollection) return <div className="route-collection-tile-placeholder" data-testid="placeholder" />

    const url = routeCollection.getUrl()

    return (
        <div className="route-collection-tile">
            <div className="tile-media">
                <Tag icon="i-collection">{collection}</Tag>
                {routeCollection.image ? (
                    <img src={routeCollection.image} alt={routeCollectionImage} width={330} height={195} loading='lazy' />
                ) : (
                    <i className={(icon || 'i-routes') + ' text-secondary'} />
                )}
            </div>
            <h5 className="tile-title">
                {url ? (
                    <a className="tile-link" href={url}>
                        {routeCollection.title}
                    </a>
                ) : routeCollection.title}
            </h5>
            <small className="text-secondary">{routeCollection.routeCount} {routes}</small>
        </div>
    )
}

export default translated(RouteCollectionTile)
